@if (approvals().length) {
  <div class="self-stretch justify-start text-text-color text-sm font-semibold font-['Inter'] leading-5 pt-2">{{ heading() }}</div>
  <div class="grid w-fit max-w-full gap-x-6 gap-y-2 pb-4" [ngClass]="canOverrideApprovers() ? 'grid-cols-5' : 'grid-cols-4'">
    <div class="h-[1px] bg-surface-200 my-[2px]" [ngClass]="canOverrideApprovers() ? 'col-span-5' : 'col-span-4'"></div>
    <div class="flex items-center text-text-color text-sm font-normal font-['Inter'] leading-5"><b>Approver/Group</b></div>
    <div class="flex items-center text-text-color text-sm font-normal font-['Inter'] leading-5"><b>Approval Status</b></div>
    <div class="flex items-center text-text-color text-sm font-normal font-['Inter'] leading-5"><b>Type</b></div>
    <div class="flex items-center text-text-color text-sm font-normal font-['Inter'] leading-5"><b>Details</b></div>
    @if (canOverrideApprovers()) {
      <div class="flex items-center text-text-color text-sm font-normal font-['Inter'] leading-5"><b>Action</b></div>
    }
    <div class="h-[1px] bg-surface-200 my-[2px]" [ngClass]="canOverrideApprovers() ? 'col-span-5' : 'col-span-4'"></div>
    @for (approval of approvals(); track approval) {
      <div class="flex items-center text-text-color text-sm font-normal font-['Inter'] leading-5">
        {{ approverLabel(approval) }}
      </div>
      <div class="flex items-center">
        <p-badge [severity]="statusBadge(approval).severity" [value]="statusBadge(approval).label" />
      </div>
      <div class="flex items-center text-text-color text-sm font-normal font-['Inter'] leading-5">{{toInitialTypeText(approval.actionContext ?? '')}}</div>
      <div class="flex items-center text-text-color text-sm font-normal font-['Inter'] leading-5">
        @if (approval.status === 'Actioned') {
          <!-- The actioning user is named by the Approver/Group column, so this is date only. -->
          {{(toApprovalTypeText(approval.actionType ?? '')) + ' on ' + (approval.actionedDate ?? '' | date: 'dd/MM/yy')}}
        }
      </div>
      @if (canOverrideApprovers()) {
        <div class="flex items-start">
          <p-button [style]="{height:'1.5em'}" [text]="true" severity="primary" size="small" (onClick)="openManageApproversModal()">
            <span class="text-nowrap text-sm font-['Inter']">Edit Approvers</span>
          </p-button>
        </div>
      }
      <div class="h-[1px] bg-surface-200 my-[2px]" [ngClass]="canOverrideApprovers() ? 'col-span-5' : 'col-span-4'"></div>
    }
  </div>
}
